
import { Component, Vue } from 'vue-property-decorator'
import { CarBaseInfo } from '@/types/carManage'

@Component({
  name: 'CarManageBaseList',
  components: {}
})
export default class extends Vue {
  private info = {
    projectName: '',
    vehicleName: '',
    deviceNumber: '',
    vehicleType: ''
  }

  private page = 1
  private size = 10
  private total = 0
  private carTypeList = []
  private loading = false
  private tableData: CarBaseInfo[] = []
  get projectList () {
    return this.$store.state.projectList
  }

  created () {
    this.getList()
    this.getCarTypeList()
  }

  onSearch () {
    this.page = 1
    this.getList()
  }

  getList () {
    this.loading = true
    this.$axios
      .get<{ total: number; list: CarBaseInfo[] }>(
        this.$apis.carManage.selectYhVehicleByPage,
        {
          ...this.info,
          page: this.page,
          size: this.size
        }
      )
      .then((res) => {
        if (res) {
          this.total = res.total || 0
          this.tableData = res.list || []
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  // 车辆类型
  getCarTypeList () {
    this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'vehicleType' }).then(res => {
      this.carTypeList = res.vehicleType || []
    })
  }

  // 新增车辆
  onAdd () {
    this.$router.push({ name: 'addBase' })
  }

  // 编辑
  onEdit (id: string) {
    this.$router.push({
      name: 'editBase',
      params: {
        id
      }
    })
  }

  // 查看
  onDetail (id: string) {
    this.$router.push({
      name: 'detailBase',
      params: {
        id
      }
    })
  }

  // 删除
  onDelete (vehicleId: string) {
    this.$confirm('确认删除吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.loading = true
        this.$axios.post(this.$apis.carManage.deleteYhVehicle, { vehicleId }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        }).finally(() => {
          this.loading = false
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getState (state: string) {
    const arr = ['', '未开工', '在建', '已移交']
    return arr[Number(state)]
  }
}
